import { Component, OnInit, Input } from '@angular/core';
import { DistributionViewAddress } from '../../distribution-view.model';

@Component({
    selector: 'distribution-contact-address-view',
    templateUrl: './address-view.component.html',
    styleUrls: ['./address-view.component.scss']
})
export class AddressViewComponent implements OnInit {
    @Input() address: DistributionViewAddress;
    @Input() contactType: string;
    @Input() netpoint: boolean;

    constructor() {}

    ngOnInit(): void {
        
    }
}
